import { createContext, useContext } from "react";

import type { MobileMenuContextProps } from "./MobileMenu.types";

export const MobileMenuContext = createContext<MobileMenuContextProps>({});

export const useMobileMenu = (): MobileMenuContextProps => {
  const context = useContext(MobileMenuContext);

  if (!context) {
    throw new Error("useMobileMenu must be used within a MobileMenuContext");
  }

  return context;
};
